import { createAsyncThunk } from "@reduxjs/toolkit";
import CasesAPI, { UpdateCaseRequest, GetCasesResponse, GetCasesParams } from "../api/cases";


export const updateCase = createAsyncThunk<
    void,
    {caseId: string, request: UpdateCaseRequest},
    {rejectValue: string}
>(
    'cases/update',
    async ({caseId, request}, {rejectWithValue}) => {
        try {
            await CasesAPI.update(caseId, request);
        } catch(error: any) {
            console.error(error);
            const errorMessage = error.response?.data?.message || "An unexpected error occurred. Please try again.";
            return rejectWithValue(errorMessage);
        }
    }
)


export const fetchCaseInfo = createAsyncThunk<
    GetCasesResponse, 
    { case_id: string },
    { rejectValue: void }
>(
    "cases/fetchCaseInfo",
    async ({ case_id }, { rejectWithValue }) => {
        try {
            const params: GetCasesParams = {
                case_id: [case_id],
            };
            const response = await CasesAPI.get(params);
            return response;
        } catch (error) {
            console.error(error);
            return rejectWithValue();
        }
    }
);